export default __webpack_public_path__ + "static/media/icon-selectionnez un patient.71a8b48c.svg";